import React from 'react';

interface OptiVeloLogoProps {
  className?: string;
  size?: number;
  variant?: 'icon' | 'full';
}

export const OptiVeloLogo: React.FC<OptiVeloLogoProps> = ({ className = "", size = 24, variant = 'icon' }) => {
  const Icon = ({ s }: { s: number }) => (
    <svg 
      width={s} 
      height={s} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100" height="100" rx="28" fill="url(#logoGradient)" />
      <path d="M30 40C36.6667 36.6667 43.3333 43.3333 50 40C56.6667 36.6667 63.3333 43.3333 70 40" stroke="white" strokeWidth="6" strokeLinecap="round" />
      <path d="M30 52C36.6667 48.6667 43.3333 55.3333 50 52C56.6667 48.6667 63.3333 55.3333 70 52" stroke="white" strokeWidth="6" strokeLinecap="round" />
      <path d="M30 64C36.6667 60.6667 43.3333 67.3333 50 64C56.6667 60.6667 63.3333 67.3333 70 64" stroke="white" strokeWidth="6" strokeLinecap="round" />
      <defs>
        <linearGradient id="logoGradient" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6366F1" />
          <stop offset="1" stopColor="#A855F7" />
        </linearGradient>
      </defs>
    </svg>
  );

  if (variant === 'full') {
    return (
      <div className={`flex flex-col items-center gap-1 ${className}`}>
        <div className="flex items-center gap-2 relative group">
          <Icon s={size} />
          <span 
            className="text-white font-bold tracking-tighter" 
            style={{ fontSize: size * 0.85, fontFamily: "'Space Grotesk', sans-serif" }}
          >
            OptiVelo
          </span>
          <div className="absolute -top-2 -right-6 px-1.5 py-0.5 bg-gradient-to-r from-indigo-600 to-violet-600 rounded-full text-[5px] font-black text-white uppercase tracking-[0.2em] shadow-[0_0_10px_rgba(79,70,229,0.4)] border border-white/10">
            Quantum
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-[1px] w-4 bg-gradient-to-r from-transparent to-indigo-500/50" />
          <span 
            className="text-indigo-300/80 font-medium tracking-[0.3em] uppercase text-center" 
            style={{ fontSize: size * 0.18, fontFamily: "Inter, sans-serif" }}
          >
            High-Performance Ecosystem
          </span>
          <div className="h-[1px] w-4 bg-gradient-to-l from-transparent to-indigo-500/50" />
        </div>
      </div>
    );
  }

  return <Icon s={size} />;
};
